var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5"},[_c('v-row',[_c('v-col',{staticClass:"d-flex flex-row align-center justify-center flex-wrap",attrs:{"cols":"12"}},[(_vm.researches)?_c('v-btn',{staticClass:"ma-2",attrs:{"color":"success","outlined":""},on:{"click":_vm.exportTable}},[_c('v-icon',[_vm._v("mdi-file-excel-outline")]),_c('span',[_vm._v("Exporter cette étude")])],1):_vm._e()],1),_c('v-col',{attrs:{"cols":"12"}},[_c('v-simple-table',[_c('thead',[_c('tr',[_c('th',{staticClass:"by-1 br-1 bl-1 text-center",attrs:{"rowspan":2}},[_vm._v("Univers")]),_c('th',{staticClass:"by-1 br-1 text-center",attrs:{"rowspan":2}},[_vm._v("Équipe")]),_vm._l((_vm.periods),function(period){return (!_vm.compactMode)?_c('th',{staticClass:"by-1 br-1 bl-1 text-center",attrs:{"colspan":"5"},domProps:{"textContent":_vm._s(period.name)}}):_vm._e()}),_c('th',{staticClass:"by-1 br-1 bl-1 text-center",attrs:{"colspan":"5"}},[_vm._v("Total")])],2),_c('tr',[_vm._l((_vm.periods),function(period){return (!_vm.compactMode)?[_c('th',{staticClass:"bb-1 br-1 bl-1 text-center"},[_vm._v(" Budget RSE et Qualité ")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Budget R&D")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Budget Communication")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Budget Marketing")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Total")])]:_vm._e()}),_c('th',{staticClass:"bb-1 br-1 bl-1 text-center"},[_vm._v("Budget RSE et Qualité")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Budget R&D")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Budget Communication")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Budget Marketing")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Total")])],2)]),_c('tbody',[_vm._l((Object.keys(_vm.orderedTeams)),function(universId){return [_c('tr',[_c('th',{staticClass:"border",staticStyle:{"height":"3px"},attrs:{"colspan":_vm.compactMode ? 7 : 7 + 5 * _vm.periods.length}})]),_vm._l((_vm.orderedTeams[universId]),function(team,teamIndex){return _c('tr',[(teamIndex == 0)?_c('td',{staticClass:"bb-1 br-1 bl-1 text-center",attrs:{"rowspan":_vm.orderedTeams[universId].length},domProps:{"textContent":_vm._s(_vm.universeTable[universId].name)}}):_vm._e(),_c('td',{staticClass:"bb-1 br-1 text-center",domProps:{"textContent":_vm._s(team.name + '-' + team.publicName)}}),_vm._l((_vm.periods),function(period){return (!_vm.compactMode)?[_c('td',{staticClass:"bb-1 br-1 bl-1 text-center",domProps:{"textContent":_vm._s(
                    _vm.dataFormater.formatMoney(
                      _vm.researches.budgetResearch[team.univers][team.id].data[
                        period.id
                      ].quality
                    )
                  )}}),_c('td',{staticClass:"bb-1 br-1 text-center",domProps:{"textContent":_vm._s(
                    _vm.dataFormater.formatMoney(
                      _vm.researches.budgetResearch[team.univers][team.id].data[
                        period.id
                      ].rnd
                    )
                  )}}),_c('td',{staticClass:"bb-1 br-1 text-center",domProps:{"textContent":_vm._s(
                    _vm.dataFormater.formatMoney(
                      _vm.researches.budgetResearch[team.univers][team.id].data[
                        period.id
                      ].communication
                    )
                  )}}),_c('td',{staticClass:"bb-1 br-1 text-center",domProps:{"textContent":_vm._s(
                    _vm.dataFormater.formatMoney(
                      _vm.researches.budgetResearch[team.univers][team.id].data[
                        period.id
                      ].marketing
                    )
                  )}}),_c('td',{staticClass:"bb-1 br-1 text-center",domProps:{"textContent":_vm._s(
                    _vm.dataFormater.formatMoney(
                      _vm.researches.budgetResearch[team.univers][team.id].data[
                        period.id
                      ].all
                    )
                  )}})]:_vm._e()}),_c('td',{class:'bb-1 br-1 bl-1 text-center' +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .quality == _vm.universMin[team.univers].quality
                    ? ' univers-min'
                    : '') +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .quality == _vm.universMax[team.univers].quality
                    ? ' univers-max'
                    : '') +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .quality == _vm.globalMin.quality
                    ? ' global-min'
                    : '') +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .quality == _vm.globalMax.quality
                    ? ' global-max'
                    : ''),domProps:{"textContent":_vm._s(
                  _vm.dataFormater.formatMoney(
                    _vm.researches.budgetResearch[team.univers][team.id].total
                      .quality
                  )
                )}}),_c('td',{class:'bb-1 br-1 text-center' +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .rnd == _vm.universMin[team.univers].rnd
                    ? ' univers-min'
                    : '') +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .rnd == _vm.universMax[team.univers].rnd
                    ? ' univers-max'
                    : '') +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .rnd == _vm.globalMin.rnd
                    ? ' global-min'
                    : '') +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .rnd == _vm.globalMax.rnd
                    ? ' global-max'
                    : ''),domProps:{"textContent":_vm._s(
                  _vm.dataFormater.formatMoney(
                    _vm.researches.budgetResearch[team.univers][team.id].total.rnd
                  )
                )}}),_c('td',{class:'bb-1 br-1 text-center' +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .communication == _vm.universMin[team.univers].communication
                    ? ' univers-min'
                    : '') +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .communication == _vm.universMax[team.univers].communication
                    ? ' univers-max'
                    : '') +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .communication == _vm.globalMin.communication
                    ? ' global-min'
                    : '') +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .communication == _vm.globalMax.communication
                    ? ' global-max'
                    : ''),domProps:{"textContent":_vm._s(
                  _vm.dataFormater.formatMoney(
                    _vm.researches.budgetResearch[team.univers][team.id].total
                      .communication
                  )
                )}}),_c('td',{class:'bb-1 br-1 text-center' +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .marketing == _vm.universMin[team.univers].marketing
                    ? ' univers-min'
                    : '') +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .marketing == _vm.universMax[team.univers].marketing
                    ? ' univers-max'
                    : '') +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .marketing == _vm.globalMin.marketing
                    ? ' global-min'
                    : '') +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .marketing == _vm.globalMax.marketing
                    ? ' global-max'
                    : ''),domProps:{"textContent":_vm._s(
                  _vm.dataFormater.formatMoney(
                    _vm.researches.budgetResearch[team.univers][team.id].total
                      .marketing
                  )
                )}}),_c('td',{class:'bb-1 br-1 text-center' +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .all == _vm.universMin[team.univers].all
                    ? ' univers-min'
                    : '') +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .all == _vm.universMax[team.univers].all
                    ? ' univers-max'
                    : '') +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .all == _vm.globalMin.all
                    ? ' global-min'
                    : '') +
                  (_vm.researches.budgetResearch[team.univers][team.id].total
                    .all == _vm.globalMax.all
                    ? ' global-max'
                    : ''),domProps:{"textContent":_vm._s(
                  _vm.dataFormater.formatMoney(
                    _vm.researches.budgetResearch[team.univers][team.id].total.all
                  )
                )}})],2)})]})],2)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }